module.exports = __webpack_public_path__ + "static/img/day1.331825b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour3/day1.jpg
// module id = tWaz
// module chunks = 0